/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener('DOMContentLoaded', () => {
    let swipersCollection = [];

    const initSwipers = () => {
      if (window.innerWidth >= 768) {
        document.querySelectorAll('.tab-collections-swiper.swiper-container').forEach((container, index) => {
          if (!swipersCollection[index]) {
            swipersCollection[index] = new Swiper(container, {
              pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
              },
              navigation: {
                nextEl: '.tab-collections-swiper.swiper-container > .swiper-button-next',
                prevEl: '.tab-collections-swiper.swiper-container > .swiper-button-prev',
              },
              slidesPerView: 1,
              spaceBetween: 10,
              breakpoints: {
                  750: {
                      slidesPerView: 3,
                      spaceBetween: 4,
                  },
              },
            });
          }
        });
      } else {
        swipersCollection.forEach((swiper, index) => {
          if (swiper) {
            swiper.destroy(true, true);
            swipersCollection[index] = null;
            // Reset the slides layout after destroying swiper
            document.querySelectorAll('.tab-collections-swiper .swiper-slide').forEach(slide => {
                slide.style.width = '';
            });
          }
        });
      }
    };

    const theLookSlider = () => {
      const swiperContainer = document.querySelector('.the-look-swiper');
      const slidesPerView = swiperContainer.getAttribute('data-slides-per-view');
      new Swiper('.the-look-swiper', {
        slidesPerView: 1.3,
        spaceBetween: 8,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            // when window width is >= 640px
            640: {
                slidesPerView: parseInt(slidesPerView, 10),
                spaceBetween: 24
            }
        }
      });
    }

    const onSectionLoad = () => {
      initSwipers();
      theLookSlider();
      window.addEventListener('resize', initSwipers);
    };

    const onSectionUnload = () => {
      initSwipers();
      theLookSlider();
      swipersCollection.forEach((swiper, index) => {
        if (swiper) {
            swiper.destroy(true, true);
            swipersCollection[index] = null;
        }
      });
      window.removeEventListener('resize', initSwipers);
    };

    // Initialize Swiper on load
    initSwipers();
    theLookSlider();

    // Re-initialize Swiper on window resize
    window.addEventListener('resize', initSwipers);

    // Shopify Section Events
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:section:select', onSectionLoad);
    document.addEventListener('shopify:section:deselect', onSectionUnload);
    document.addEventListener('shopify:block:select', onSectionLoad);
    document.addEventListener('shopify:block:deselect', onSectionUnload);
    document.addEventListener('shopify:block:load', onSectionLoad);
    document.addEventListener('shopify:block:unload', onSectionUnload);

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      onSectionLoad();
    }
  });
  
  function applyAccordionBehavior() {
    document.querySelectorAll('.section-sidebar-custom .section-sidebar__title').forEach(function(label) {
      label.addEventListener('click', function() {
        label.classList.toggle('open');
        label.querySelectorAll('.icon').forEach(function(child) {
          child.classList.toggle('show');
        });
  
        var nextElement = label.nextElementSibling;
        if (label.classList.contains('open')) {
          while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
            nextElement.classList.add('open-accordion');
            nextElement = nextElement.nextElementSibling;
          }
        } else {
          while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
            nextElement.classList.remove('open-accordion');
            nextElement = nextElement.nextElementSibling;
          }
        }
      });
    });
  }
  
  function removeAccordionBehavior() {
    document.querySelectorAll('.section-sidebar__title').forEach(function(label) {
      label.removeEventListener('click', toggleAccordion);
    });
  }
  
  function toggleAccordion(event) {
    var label = event.currentTarget;
    label.classList.toggle('open');
    label.querySelectorAll('.icon').forEach(function(child) {
      child.classList.toggle('show');
    });
  
    var nextElement = label.nextElementSibling;
    if (label.classList.contains('open')) {
      while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
        nextElement.classList.add('open-accordion');
        nextElement = nextElement.nextElementSibling;
      }
    } else {
      while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
        nextElement.classList.remove('open-accordion');
        nextElement = nextElement.nextElementSibling;
      }
    }
  }
  
  function updateAccordionBehavior() {
    if (window.matchMedia('(max-width: 750px)').matches) {
      applyAccordionBehavior();
    } else {
      removeAccordionBehavior();
    }
  }
  updateAccordionBehavior();
  window.addEventListener('resize', updateAccordionBehavior);
  
  function applyAccordionBehavior() {
    document.querySelectorAll('.section-sidebar-custom .section-sidebar__title').forEach(function(label) {
      label.addEventListener('click', function() {
        label.classList.toggle('open');
        label.querySelectorAll('.icon').forEach(function(child) {
          child.classList.toggle('show');
        });
  
        var nextElement = label.nextElementSibling;
        if (label.classList.contains('open')) {
          while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
            nextElement.classList.add('open-accordion');
            nextElement = nextElement.nextElementSibling;
          }
        } else {
          while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
            nextElement.classList.remove('open-accordion');
            nextElement = nextElement.nextElementSibling;
          }
        }
      });
    });
  }
  
  function removeAccordionBehavior() {
    document.querySelectorAll('.section-sidebar__title').forEach(function(label) {
      label.removeEventListener('click', toggleAccordion);
    });
  }
  
  function toggleAccordion(event) {
    var label = event.currentTarget;
    label.classList.toggle('open');
    label.querySelectorAll('.icon').forEach(function(child) {
      child.classList.toggle('show');
    });
  
    var nextElement = label.nextElementSibling;
    if (label.classList.contains('open')) {
      while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
        nextElement.classList.add('open-accordion');
        nextElement = nextElement.nextElementSibling;
      }
    } else {
      while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
        nextElement.classList.remove('open-accordion');
        nextElement = nextElement.nextElementSibling;
      }
    }
  }
  
  function updateAccordionBehavior() {
    if (window.matchMedia('(max-width: 750px)').matches) {
      applyAccordionBehavior();
    } else {
      removeAccordionBehavior();
    }
  }
  updateAccordionBehavior();
  window.addEventListener('resize', updateAccordionBehavior);
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
